import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import { theme } from '_constants/theme';

import Avatar from 'components/shared/Avatar';

const StyledContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;

  > div:first-child {
    margin-right: ${theme.spaces.regular}px;
  }
`;

const StyledName = styled.div`
  max-width: 160px;
  font-family: 'RethinkSans';
  font-size: ${theme.fontSizes.small}px;
  font-weight: 400;
  line-height: 16px;
  color: ${theme.colors.white};

  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;

  @media ${theme.devices.tablet} {
    width: 90px;
  }
`;

const StyledRole = styled.div`
  font-family: 'RethinkSans';
  font-size: ${theme.fontSizes.smallX}px;
  font-weight: 400;
  line-height: 16px;
  color: ${theme.colors.white};
`;

const UserInfo = ({ avatarUrl, name, role, ...restProps }) => {
  return (
    <StyledContainer {...restProps}>
      <div>
        <Avatar url={avatarUrl} name={name} />
      </div>
      <div>
        <StyledName title={name}>{name}</StyledName>
        {role && <StyledRole>{role}</StyledRole>}
      </div>
    </StyledContainer>
  );
};

UserInfo.propTypes = {
  avatarUrl: PropTypes.string,
  name: PropTypes.string,
  role: PropTypes.string,
};

export default UserInfo;
